import { render } from "./ShippingSection.vue?vue&type=template&id=a30aaeee"
import script from "./ShippingSection.vue?vue&type=script&lang=js"
export * from "./ShippingSection.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__